import Events from "./EventLite";
import UpdateLoop from "../Libs/Vexr/GameLoop";
import Screen from "./Screen";
import VotingItem from "../views/Components/VotingItem";
import SelectedPumpkin from "../views/Components/SelectedPumpkin";


export default class VotingGame {
    constructor(selections, parentElement, pumpkins) {
        this.pumpkins = pumpkins;
        this.parentElement = parentElement;
        this.selections = selections;
        this.selectionContainer = document.createElement("div");
        this.selectionContainer.classList.add("selections");
        this.positionA = null;
        this.positionB = null;
        this.parentElement.appendChild(this.selectionContainer);
        this.selectionElements = this.createElements(this.selectionContainer);
        this.selected = null;
        this.selectedPumpkin = null;
        this.postGame = document.getElementById("post-game-actions");
        this.voteProgress = document.getElementById("vote-progress-group");
        this.selectedPumpkinElement = document.getElementById("SelectedPumpkin");
        this.updateloop = new UpdateLoop();
        this.updateloop.loop();

        this.progressHeight = 200;
        this.progressBase = 6;
        this.progressSpace = Math.floor(200 / (this.selections.length-1));

        this.drawProgress();

        this.setPositionLocations();

        Events.on("resize", this.setPositionLocations.bind(this));
        Events.on("updateProgress", this.updateProgress.bind(this));

    }

    drawProgress () {
        var base = this.progressBase;
        var height = this.progressHeight;
        var space = this.progressSpace;
        this.selections.forEach((selection, i)=>{
            var circle = document.createElementNS("http //www.w3.org/2000/svg", "circle");
                circle.setAttribute("class", "off")
                circle.setAttribute("cx", 14);
                circle.setAttribute("cy", base + ( i * space ));
                circle.setAttribute("r", 5);
                this.voteProgress.appendChild(circle);
        });
        this.swapSVG();
    }

    swapSVG () {
        var svg = document.getElementById("vote-progress");
        var html = svg.innerHTML;
            svg.innerHTML = "";
            svg.innerHTML = html;
            this.voteProgress = document.getElementById("vote-progress-group");
    }

    static RemoveChildrenOfParent(parent) {
        while (parent.firstChild) {
            parent.firstChild.remove();
        }
    }

    createElements (parent) {
        var elements = [];
        for ( var i =0; i < this.selections.length; i++) {
            var selection = new VotingItem(this.selections[i]);
            selection.addToParent(parent);
            elements.push(selection);
        }
        return elements;
    }

    removeElement (selection) {
        selection.destroy();
    }
    removeElements (array) {
        for (var i = 0; i < array.length; i++) {
            array[i].hide();
            this.removeElement(array[i]);
        }
    }

    updateProgress (length, total) {

        if(length ==0){
            length=1;
        }
        var roundvalue = document.getElementById("roundvalue");
        var roundquestion = document.getElementById("roundquestion");
        var vs = document.getElementsByClassName("progress")[0];

        var votes = this.voteProgress.childNodes;
        var nodes = Array.from(votes);

        var spider = document.getElementsByClassName("Spider")[0];
            spider.setAttribute("style", `transform: translateY(${(this.progressBase+20)+(this.progressSpace*(length-2))}px);`);

        nodes.forEach((element,i)=>{
            if( i < length-1 ) {
                element.classList.add("on");
                element.classList.remove("off");
            }
        });

        if(length < total) {
            vs.classList.add("show");
            vs.classList.remove("hide");
            roundvalue.innerHTML = `Round ${length+1}`;
            roundquestion.innerHTML = "CHOOSE A PUMPKIN FOR JACK";
        } else {
            VotingGame.RemoveChildrenOfParent(this.voteProgress);
            vs.classList.add("hide");
            vs.classList.remove("show");
            roundvalue.innerHTML = `Vote`;
            roundquestion.innerHTML = "WOULD YOU GIVE THIS PUMPKIN TO JACK?";
        }
    }


    setPositionLocations (e) {
        if (this.positionA != null) {
            this.positionA.location = Screen.getAnchor("positionA"+Screen.orientation);
            this.positionA.element.classList.add("active");
            this.positionA.render();
        }

        if (this.positionB != null) {
            this.positionB.location = Screen.getAnchor("positionB"+Screen.orientation);
            this.positionB.element.classList.add("active");
            this.positionB.render();
        }
    }

    getRemainingContestants() {
        var selectionPool = this.selectionElements.filter((contestant)=>{return !contestant.voted});
        return VotingGame.shuffle(selectionPool);
    }

    getASelectableElement(selectionPool) {

        var randomIndex = Math.abs(Math.ceil(Math.random() * selectionPool.length-1));

        var selection = selectionPool[randomIndex];
            selection.voted = true;

        return selection;

    }

    static shuffle (array) {
        var m = array.length, t, i;
        while (m) {
            i = Math.floor(Math.random() * m--);
            t = array[m];
            array[m] = array[i];
            array[i] = t;
        }
        return array;
    }

    nextRound() {
        var selectionPool = this.getRemainingContestants();
        Events.trigger("updateProgress", this.selectionElements.length - selectionPool.length, this.selectionElements.length);

        if(selectionPool.length > 0) {
            if (this.positionA == null) {
                this.positionA = this.getASelectableElement(selectionPool);
                this.positionA.position = "A";
                this.positionA.makeSelection = this.makeSelection.bind(this, this.positionA);
                this.positionA.element.addEventListener("mousedown", this.positionA.mousedown);
                this.positionA.element.addEventListener("mouseup", this.positionA.makeSelection);
                this.positionA.element.addEventListener("mouseover", this.positionA.overeffect);
                this.positionA.element.addEventListener("mouseout", this.positionA.outeffect);
            }

            selectionPool = this.getRemainingContestants(); // prevents duplicates

            if (this.positionB == null) {
                this.positionB = this.getASelectableElement(selectionPool);
                this.positionB.position = "B";
                this.positionB.makeSelection = this.makeSelection.bind(this, this.positionB);
                this.positionB.element.addEventListener("mousedown", this.positionB.mousedown);
                this.positionB.element.addEventListener("mouseup", this.positionB.makeSelection);
                this.positionB.element.addEventListener("mouseover", this.positionB.overeffect);
                this.positionB.element.addEventListener("mouseout", this.positionB.outeffect);
            }

            this.positionA.location = Screen.getAnchor("positionA"+Screen.orientation);
            this.positionB.location = Screen.getAnchor("positionB"+Screen.orientation);

            this.positionA.show();
            this.positionA.render();
            this.positionB.show();
            this.positionB.render();

        } else {
            this.gameComplete();
        }
    }

    gameComplete () {

        this.selected.element.removeEventListener("mousedown", this.selected.mousedown);
        this.selected.element.removeEventListener("mouseup", this.selected.makeSelection);
        this.selected.element.removeEventListener("mouseover", this.selected.overeffect);
        this.selected.element.removeEventListener("mouseout", this.selected.outeffect);
        this.selected.location = Screen.getAnchor("center");
        this.selected.scale = 0;
        this.selected.element.classList.add("selected");
        this.selected.render();
        this.selectedPumpkin = new SelectedPumpkin(this.selected.data);
        this.updateloop.addActor(this.selectedPumpkin);
        
        this.postGame.classList.add("show");
        this.postGame.classList.remove("hide");
        ga('send', 'event', 'Voting', 'Preselection Voting Complete');

    }

    resetGame () {
        this.removeElements( this.selectionElements );
        this.selectionElements = this.createElements(VotingGame.shuffle(this.selectionContainer));
        this.updateloop.gameObjects = [];
        this.positionA = null;
        this.positionB = null;
        this.selected = null;

        VotingGame.RemoveChildrenOfParent(this.voteProgress);
        this.drawProgress();

        this.selectedPumpkin.destroy();

        this.postGame.classList.remove("show");
        this.postGame.classList.add("hide");

        this.nextRound();

        Events.trigger("play", "Restart");

        ga('send', 'event', 'Voting','Reset Game');
    }

    makeSelection (item) {
       // item.scale = 1;
        this.selected = item;
        var rejectedItem;
        if (item.position == "A") {
            rejectedItem = this.positionB;
            this.positionB = null;
        }
        if (item.position == "B") {
            rejectedItem = this.positionA;
            this.positionA = null;
        }
        rejectedItem.velocity.add(rejectedItem.catapultDir);
        rejectedItem.element.classList.remove("show");
        rejectedItem.element.classList.add("voted");
        rejectedItem.element.removeEventListener("mousedown", rejectedItem.mousedown);
        rejectedItem.element.removeEventListener("mouseup", rejectedItem.makeSelection);
        rejectedItem.element.removeEventListener("mouseover", rejectedItem.overeffect);
        rejectedItem.element.removeEventListener("mouseout", rejectedItem.outeffect);
        this.updateloop.addActor(rejectedItem);

        this.nextRound();

        Events.trigger("play", "Select");

        ga('send', 'event',  'Killed Pumpkin', rejectedItem.data.Name);
    }

}


// WEBPACK FOOTER //
// ./src/Utils/VotingGame.js